  function readMore(btn){
    if (btn.classList.contains('more')) {
        btn.classList.remove('more');
        btn.innerHTML='show less';
        btn.parentElement.querySelector('.text-overflow').style.height='auto';
    } else {
        btn.classList.add('more');
        btn.innerHTML='show more';
        btn.parentElement.querySelector('.text-overflow').style.height='36px';
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    var text = document.getElementsByClassName('text-overflow');;
    var btn = document.getElementsByClassName('btn-overflow');
    for (var i=0; i<text.length; i++) {
      var height = text[i].scrollHeight;
      //check height of text
      if(height > 36) {
      	btn[i].classList.add('more');
      	btn[i].style.display='block';
      }
    }
    //show menu by default
    var id = window.location.toString().split('#')[1];
    //get menu button href list
    var links=document.getElementsByClassName("menu_btn"), hrefs = [];
    for (var i = 0; i<links.length; i++){   
      hrefs.push(links[i].getAttribute("href").toString().split('#')[1]);
    }
    //show defaul pr selected menu
    if (id === undefined || id === null) {
      showMenu("EyebrowsAndEyelashes")
    }
    else if(!hrefs.includes(id)){
      showMenu("EyebrowsAndEyelashes");
    }
    else {
      showMenu(id);
    }

    var menuBtns = document.getElementsByClassName("menu_btn")
    for (let i = 0; i < menuBtns.length; i++) {
        menuBtns[i].addEventListener("click", (event) => {
            var menuBtns = document.getElementsByClassName("menu_btn")
            for (let j = 0; j < menuBtns.length; j++) {
                menuBtns[j].classList.remove("selected")
            }

            event.currentTarget.classList.add("selected")
            var boxCollection = document.getElementsByClassName("box");
            var subCategoryBox = document.getElementsByClassName("sub-category-title-box");

            for (let i = 0; i < boxCollection.length; i++) {
                var element = Array.from(boxCollection[i].classList)
                if (element.includes(event.currentTarget.dataset.selector)) {
                    boxCollection[i].style.display = "inline-flex"
                    boxCollection[i].getElementsByTagName('a')[0].style.display = "inline-flex"
                } else {
                    boxCollection[i].style.display = "none"
                }
            }

            for (let i = 0; i < subCategoryBox.length; i++) {
                var element = Array.from(subCategoryBox[i].classList)
                if (element.includes(event.currentTarget.dataset.selector)) {
                    subCategoryBox[i].style.display = "block"
                } else {
                    subCategoryBox[i].style.display = "none"
                }
            }
        });
    }
    // toggle menu
    // document.getElementsByClassName("toogle-btn")[0].addEventListener("click", (event) => {
    //   if (document.getElementsByClassName("toogle-btn")[0].classList.contains('hide')) {
    //       showMenu();
    //   } else {
    //       hideMenu();
    //   }
    // });

    function showMenu(id){
      //document.getElementsByClassName("pagetitle")[0].innerHTML = "Services"
      //document.getElementsByClassName("toogle-btn")[0].classList.remove('hide');
      //document.getElementsByClassName("toogle-btn")[0].innerHTML = "View All";
      document.getElementsByClassName("menu")[0].style.display = "flex";
      document.querySelector(`[data-selector="${id}"]`).classList.add("selected");

      var boxCollection = document.getElementsByClassName("box");
      for (let i = 0; i < boxCollection.length; i++) {
          var element = Array.from(boxCollection[i].classList);
          //show EyebrowsAndEyelashes category by default
          if (!element.includes(id)) {
              boxCollection[i].style.display = "none";
          }
      }

      var categoryTitleBox = document.getElementsByClassName("category-title-box");
      for (let i = 0; i < categoryTitleBox.length; i++) {
          var element = Array.from(categoryTitleBox[i].classList);
          if (!element.includes(id)) {
            categoryTitleBox[i].style.display = "none";
          }
      }
      
      var subCategoryBox = document.getElementsByClassName("sub-category-title-box");
      for (let i = 0; i < subCategoryBox.length; i++) {
          var element = Array.from(subCategoryBox[i].classList);
          if (!element.includes(id)) {
            subCategoryBox[i].style.display = "none";
          }
      }
    }

    function hideMenu(){
      // document.getElementsByClassName("pagetitle")[0].innerHTML = "All Services"
      // document.getElementsByClassName("toogle-btn")[0].classList.add('hide');
      // document.getElementsByClassName("toogle-btn")[0].innerText = "View Categories";
      document.getElementsByClassName("menu")[0].style.display = "none";
      
      var boxCollection = document.getElementsByClassName("box");
      for (let i = 0; i < boxCollection.length; i++) {
          boxCollection[i].style.display = "inline-flex";
          boxCollection[i].getElementsByTagName('a')[0].style.display = "inline-flex";
      }
      var categoryTitleBox = document.getElementsByClassName("category-title-box");
      for (let i = 0; i < categoryTitleBox.length; i++) {
          categoryTitleBox[i].style.display = "block";
      }
      
      var subCategoryBox = document.getElementsByClassName("sub-category-title-box");
      for (let i = 0; i < subCategoryBox.length; i++) {
          subCategoryBox[i].style.display = "block";
      }
    }
  });